import type { FC } from "react";

import {
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator
} from "@/components/ui/select";

import {
  CUSTOM_STYLE_LABEL,
  MORE_PRESETS,
  MORE_STYLES_LABEL,
  PRIMARY_PRESETS,
  type ExhibitStylePreset
} from "../exhibitStylePresets";

/** The Select value that opens the level builder rather than picking a preset. */
export const CUSTOM_STYLE_VALUE = "__custom";

type Props = {
  /** "A.  A.1.": the samples a More Styles preset shows. */
  samples: (preset: ExhibitStylePreset) => string;
  testIdPrefix: string;
  /** Leave out Custom… (a member, or nowhere to save it). */
  withCustom?: boolean;
};

/**
 * A label-style Select's items: the two primary styles, More Styles, then
 * Custom…. The caller's `onValueChange` handles `CUSTOM_STYLE_VALUE`.
 */
export const ExhibitStyleSelectItems: FC<Props> = ({
  samples,
  testIdPrefix,
  withCustom = true
}) => (
  <>
    {PRIMARY_PRESETS.map((preset) => (
      <SelectItem
        key={preset.id}
        value={preset.id}
        data-testid={`${testIdPrefix}-${preset.id}`}
      >
        {preset.label}
      </SelectItem>
    ))}
    <SelectSeparator />
    <SelectGroup data-testid={`${testIdPrefix}-more`}>
      <SelectLabel>{MORE_STYLES_LABEL}</SelectLabel>
      {MORE_PRESETS.map((preset) => (
        <SelectItem
          key={preset.id}
          value={preset.id}
          data-testid={`${testIdPrefix}-${preset.id}`}
        >
          <span className="flex-1 truncate">{preset.label}</span>
          <span className="ml-3 shrink-0 font-mono text-sm text-fg-4 tabular-nums">
            {samples(preset)}
          </span>
        </SelectItem>
      ))}
    </SelectGroup>
    {withCustom ? (
      <>
        <SelectSeparator />
        <SelectItem
          value={CUSTOM_STYLE_VALUE}
          data-testid={`${testIdPrefix}-custom`}
        >
          {CUSTOM_STYLE_LABEL}
        </SelectItem>
      </>
    ) : null}
  </>
);
